import messages from '../../../locale/messages';

export function getRefundStatus(item) {
    let status;
    if (item.refundStatus && item.refundStatus.id) {
        status = messages.completedLabel;
    } else if (item.guestFailedTransaction && item.guestFailedTransaction.id) {
        status = messages.failed;
    } else if (item.refundStatus == null && item.guestFailedTransaction == null && (item.reservationState == 'expired' || item.reservationState == 'declined')) {
        status = messages.messageStatus5;
    } else if (item.reservationState == 'cancelled' && (item.cancellationDetails.refundToGuest == 0 || item.cancellationDetails.refundToGuest < 0)) {
        status = messages.closedLabel;
    } else if (item.reservationState == 'cancelled' && item.cancellationDetails.refundToGuest > 0 && item.refundStatus == null && item.guestFailedTransaction == null) {
        status = messages.messageStatus5;
    }

    return status;
}